import { html } from '@polymer/polymer/polymer-element.js';
import { KatapultWidget } from './katapult-widget';

class TestPaperHeader extends KatapultWidget {
  static get headerTemplate() {
    return html`Time Calculator`;
  }

  static get contentTemplate() {
    return html`
      <style>
        #notes {
          font-size: 14pt;
          color: #424242;
        }
      </style>
      <h1>Notes</h1>
      <div id="notes" contenteditable="true">This can be used to jot down notes.</div>
    `;
  }

  static get bodyTemplate() {
    return html`
      <style>
        iframe {
          height: 900px;
          width: 100%;
        }
      </style>
      <iframe src="https://www.calculator.net/time-calculator.html">Time Calculator</iframe>
    `;
  }

  static get properties() {
    return {
      paperHeader: {
        type: Boolean,
        value: true // default is false
      }
    };
  }

  ready() {
    super.ready();
  }
}
window.customElements.define('test-paper-header', TestPaperHeader);
